<template>
    <div class="content">
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-9">
                    <card>
                        <h5 slot="header" class="card-title"><span @click="goBack()" class="link">Назад</span> -
                            Общая информация</h5>
                        <div class="loader" v-if="waiting"></div>
                        <form v-if="template">
                            <div class="row">

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label class="control-label">Категория</label>
                                        <select v-model="template.category_id"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-if="c.id !== 999" v-for="c in categories" v-bind:value="c.id">
                                                {{ c.name }}
                                            </option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Статус</label>
                                        <select v-model="template.status"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="1">Опубликовано</option>
                                            <option value="0">Ожидает</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Минимальная версия</label>
                                        <select v-model="template.v"
                                                id="status-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="">Все версии</option>
                                            <option value="2.0">2.0</option>
                                            <option value="2.1">2.1</option>
                                            <option value="2.2">2.2</option>
                                            <option value="2.7">2.7</option>
                                            <option value="2.8">2.8</option>
                                            <option value="2.9">2.9</option>
                                            <option value="3.0">3.0</option>
                                            <option value="3.1">3.1</option>
                                            <option value="3.2">3.2</option>
                                            <option value="3.3">3.3</option>
                                            <option value="3.4">3.4</option>
                                            <option value="3.5">3.5</option>
                                            <option value="3.6">3.6</option>
                                            <option value="3.7">3.7</option>
                                            <option value="3.8">3.8</option>
                                            <option value="4.0">4.0</option>
                                            <option value="4.1">4.1</option>
                                            <option value="4.2">4.2</option>
                                            <option value="4.3">4.3</option>
                                            <option value="4.4">4.4</option>
                                            <option value="4.5">4.5</option>
                                            <option value="4.6">4.6</option>
                                            <option value="5.0">5.0</option>
                                            <option value="5.1">5.1</option>
                                            <option value="5.2">5.2</option>
                                            <option value="5.3">5.3</option>
                                            <option value="5.4">5.4</option>
                                            <option value="5.5">5.5</option>
                                            <option value="5.6">5.6</option>
                                        </select>
                                    </div>
                                    <fg-input type="text"
                                              label="Сортировка (чем больше, тем выше в списке)"
                                              v-model="template.sort"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Название трека"
                                              v-model="template.song"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на Reels audio"
                                              v-model="template.song_insta"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text" v-if="template.is_copyrighted"
                                              label="Ссылка на TikTok audio"
                                              v-model="template.song_tiktok"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="date"
                                              label="Дата публикации (формат ДД.ММ.ГГГГ)"
                                              v-model="template.release_date"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="time" v-if="template.release_date"
                                              label="Время публикации (формат HH:MM)"
                                              v-model="template.release_time"
                                              placeholder="">
                                    </fg-input>
                                </div>


                                <div class="col-md-3 checkbox-block">
                                    <div class="form-group">
                                        <label for="premium-control"
                                               class="control-label label-checkbox">Премиум</label>
                                        <input v-model="template.is_premium" id="premium-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="trendy-control"
                                               class="control-label label-checkbox">Популярное</label>
                                        <input v-model="template.is_trendy" id="trendy-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="new-control" class="control-label label-checkbox">Новое</label>
                                        <input v-model="template.is_new" id="new-control" class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="trending-music-control" class="control-label label-checkbox">Трендовая
                                            музыка</label>
                                        <input v-model="template.is_trending_music" id="trending-music-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="copyrighted-control" class="control-label label-checkbox">Copyrighted-музыка</label>
                                        <input v-model="template.is_copyrighted" id="copyrighted-control"
                                               class="form-check-inline" type="checkbox">
                                    </div>
                                    <div class="form-group">
                                        <label for="text-control" class="control-label label-checkbox">Наложение
                                            текста/объекта</label>
                                        <input v-model="is_text_active" @change="toggleText()" id="text-control"
                                               class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                </div>


                                <div class="col-md-4">
                                    <div>
                                        <h5 slot="header" class="card-title">
                                            Видео: <span v-if="template.src_full">
                                            <span class="inline-link">
                                                <span v-if="template.src_size >= 4"
                                                      class="bg-danger">{{ template.src_size }}Mb</span>
                                                <span v-else-if="template.src_size >= 3"
                                                      class="bg-warning">{{ template.src_size }}Mb</span>
                                                <span v-else>{{ template.src_size }}Mb</span>
                                                <a :href="template.src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h5>

                                        <div>
                                            <input ref="videoFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.videoFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div class="margin-top">
                                        <h5 slot="header" class="card-title">
                                            Превью: <span v-if="template.preview_src_full">
                                            <span class="inline-link">
                                                <span v-if="template.preview_src_size >= 1"
                                                      class="bg-danger">{{ template.preview_src_size }}Mb</span>
                                                <span v-else-if="template.preview_src_size >= 0.5"
                                                      class="bg-warning">{{ template.preview_src_size }}Mb</span>
                                                <span v-else>{{ template.preview_src_size }}Mb</span>
                                                <a :href="template.preview_src_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h5>

                                        <div>
                                            <input ref="previewFileInput" class="btn-file" type="file"
                                                   @change="uploadFile($event, 'preview_src')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.previewFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                    <div class="margin-top">
                                        <h5 slot="header" class="card-title">
                                            Аудио: <span v-if="template.audio_full">
                                            <span class="inline-link">
                                                <span v-if="template.audio_size >= 1"
                                                      class="bg-danger">{{ template.audio_size }}Mb</span>
                                                <span v-else-if="template.audio_size >= 0.5"
                                                      class="bg-warning">{{ template.audio_size }}Mb</span>
                                                <span v-else>{{ template.audio_size }}Mb</span>
                                                <a :href="template.audio_full" target="_blank">(ссылка)</a></span>
                                        </span>
                                        </h5>

                                        <div>
                                            <input ref="audioFileInput" class="btn-file" type="file"
                                                   accept="audio/mp3"
                                                   @change="uploadFile($event, 'audio')">
                                            <button type="submit" class="btn btn-info btn-fill upload-button"
                                                    @click="$refs.audioFileInput.click()">
                                                Загрузить
                                            </button>
                                            <div class="clearfix"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!--                            <div class="text-center">-->
                            <!--                                <div class="btn btn-danger btn-fill float-left btn-save"-->
                            <!--                                     @dblclick="remove()">-->
                            <!--                                    Удалить-->
                            <!--                                </div>-->
                            <!--                            </div>-->

                            <div class="text-center">
                                <button type="submit" class="btn btn-success btn-fill float-right btn-save"
                                        :disabled="!template.duration || !template.videos || !template.category_id || !template.song || !template.src || !template.preview_src || !template.audio
                                        || (template.is_copyrighted == true && (!template.song_insta && !template.song_tiktok))"
                                        @click.prevent="save">
                                    Сохранить
                                </button>
                            </div>
                            <div class="clearfix"></div>
                        </form>
                    </card>

                    <card v-show="is_text_active">

                        <h4 slot="header" class="card-title">
                            Текст</h4>

                        <div class="texts-buttons" v-if="is_text_active">
                            <button v-for="(t, index) in template.texts"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_text && active_type === 'text'}"
                                    @click="selectText(index)">{{ t.text }}
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button v-for="(t, index) in template.objects"
                                    type="button" class="btn btn-text btn-fill"
                                    :class="{ 'active' : index === active_object && active_type === 'object'}"
                                    @click="selectObject(index)"><img alt="" class="button-preview"
                                                                      :src="`static/objects/${t.category}/${t.id}`">
                                <span class="animated-icon" v-if="t.animation_type !== 0">•</span>
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="active_type === 'text' ? addText(active_text) : addObject(null, active_object)">
                                Копировать
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="addText()">Добавить текст
                            </button>
                            <button type="button" class="btn btn-text btn-fill active control-btn"
                                    @click="showSVGModal()">Добавить объект
                            </button>
                        </div>

                        <div class="modal-mask" v-if="show_svg_modal" @click="closeSVGModal">
                            <div class="modal-wrapper">
                                <div class="modal-container">

                                    <div class="modal-header">
                                        <slot name="header">
                                            <button v-for="(t, index) in svg_list"
                                                    type="button" class="btn btn-text btn-fill"
                                                    :class="{ 'active' : t.category === active_object_category}"
                                                    @click="selectObjectCategory(t.category)">
                                                {{ t.category === 'styled_shapes' ? 'Style shapes' : t.category}}
                                            </button>
                                        </slot>
                                    </div>

                                    <div class="modal-body">
                                        <slot name="body">
                                            <div v-for="(t, index) in svg_list">
                                                <div v-for="(c, index) in t.files"
                                                     v-if="t.category === active_object_category"
                                                     class="object-item"
                                                     @click="addObject(c)">
                                                    <img alt="" :src="`static/objects/${t.category}/${c.id}`">
                                                </div>
                                            </div>
                                        </slot>
                                    </div>

                                    <div class="modal-footer">
                                        <slot name="footer">
                                            <button class="btn btn-info btn-fill modal-close-button"
                                                    @click="closeSVGModal">
                                                Закрыть
                                            </button>
                                        </slot>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <form>
                            <div class="row">
                                <div class="loader" v-if="waiting"></div>
                                <div class="col-md-4 c-labels" v-if="is_text_active && active_type === 'text'">
                                    <label class="control-label">Текст</label>
                                    <textarea class="text-area"
                                              v-model="template.texts[active_text].text">
                                    </textarea>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления текста (0 - c начала)"
                                                      v-model="template.texts[active_text].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.texts[active_text].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <label class="control-label">Размер шрифта: <span
                                        class="param-span">{{ template.texts[active_text].font_size }}</span></label>
                                    <fg-input type="range"
                                              min="5" max="200" step="1"
                                              label=""
                                              v-model="template.texts[active_text].font_size"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Шрифт</label>
                                        <select v-model="template.texts[active_text].font_name"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="f in sortedFonts" v-bind:value="f.name">{{ f.name }}</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="control1" class="control-label label-checkbox mb10">По центру по горизонтали</label>
                                        <input @change="setTextPosition(0.5, null)"
                                               :checked="template.texts[active_text].position_x == 0.5"
                                               id="control1" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label for="control2" class="control-label label-checkbox mb10">По центру по вертикали</label>
                                        <input @change="setTextPosition(null, 0.5)"
                                               :checked="template.texts[active_text].position_y == 0.5"
                                               id="control2" class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот текста (градусы)"
                                              v-model="template.texts[active_text].angle"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межбуквенный интервал"
                                              v-model="template.texts[active_text].letter_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Межстрочный интервал"
                                              v-model="template.texts[active_text].line_spacing"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Цвет текста: <span class="param-span">{{
                                                template.texts[active_text].text_color
                                            }}</span></label>
                                        <input type="color" v-model="template.texts[active_text].text_color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].text_color}"
                                                  @click="setColor(c, 'color')"></span>
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Цвет фона:
                                            <span class="param-span"
                                                  v-if="template.texts[active_text].background_color === 'transparent'">Прозрачный</span>
                                            <span class="param-span"
                                                  v-else>{{ template.texts[active_text].background_color }}</span>
                                        </label>
                                        <input type="color" v-model="template.texts[active_text].background_color"
                                               v-show="template.texts[active_text].background_color !== 'transparent'">
                                        <div class="clearfix"></div>
                                        <label for="background-control" class="control-label label-checkbox mb10">Прозрачный</label>
                                        <input @change="toggleBackground()"
                                               :checked="template.texts[active_text].background_color === 'transparent'"
                                               id="background-control" class="form-check-inline"
                                               type="checkbox">
                                        <div class="color-set"
                                             v-show="template.texts[active_text].background_color !== 'transparent'">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.texts[active_text].background_color}"
                                                  @click="setColor(c, 'background')"></span>
                                        </div>
                                    </div>
                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.texts[active_text].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].alpha"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Направление текста</label>
                                        <select v-model="template.texts[active_text].direction"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option value="normal">normal</option>
                                            <option value="vertical">vertical</option>
                                            <option value="round">round</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.texts[active_text].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{ t.name }}</option>
                                        </select>
                                    </div>
                                    <label v-show="template.texts[active_text].animation_type !== 0"
                                           class="control-label" >Длительность анимации: <span
                                        class="param-span">{{ template.texts[active_text].animation_duration }}</span></label>
                                    <fg-input v-show="template.texts[active_text].animation_type !== 0" type="range"
                                              min="0" max="1.5" step="0.1"
                                              label=""
                                              v-model="template.texts[active_text].animation_duration"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label class="control-label">Выравнивание <br>(если больше одной строки)</label>
                                        <select v-model="template.texts[active_text].text_align"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="ta in text_aligns" v-bind:value="ta.name">{{
                                                    ta.name
                                                }}
                                            </option>
                                        </select>
                                    </div>
                                    <label for="shadow-color">Цвет тени:</label>
                                    <input type="color" id="shadow-color"
                                           v-model="template.texts[active_text].shadow_color">
                                    <div class="clearfix"></div>
                                    <label class="control-label">Радиус размытия тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_blur }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].shadow_blur"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Видимость тени: <span
                                        class="param-span">{{ template.texts[active_text].shadow_alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.texts[active_text].shadow_alpha"
                                              placeholder="">
                                    </fg-input>
                                    <label class="control-label">Размер обводки: <span
                                        class="param-span">{{ template.texts[active_text].stroke_size }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="100" step="1"
                                              label=""
                                              v-model="template.texts[active_text].stroke_size"
                                              placeholder="">
                                    </fg-input>
                                    <label for="stroke-color">Цвет обводки:</label>
                                    <input type="color" id="stroke-color"
                                           v-model="template.texts[active_text].stroke_color">
                                    <div class="clearfix"></div>
                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.texts[active_text].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeText(active_text)">Удалить текст
                                    </button>
                                    <div class="clearfix"></div>

                                </div>


                                <div class="col-md-4 c-labels" v-if="is_text_active && active_type === 'object'">
                                    <label class="control-label">Объект</label>
                                    <img alt="" @click="changeObject()" class="object-preview"
                                         :src="`static/objects/${template.objects[active_object].category}/${template.objects[active_object].id}`">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время появления объекта (0 - c начала)"
                                                      v-model="template.objects[active_object].time_start"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                        <div class="col-md-6">
                                            <fg-input type="text"
                                                      label="Время исчезновения (пустое - до конца)"
                                                      v-model="template.objects[active_object].time_end"
                                                      placeholder="">
                                            </fg-input>
                                        </div>
                                    </div>
                                    <label class="control-label">Размер: <span
                                        class="param-span">{{ template.objects[active_object].scale }}</span></label>
                                    <fg-input type="range"
                                              min="0.03" max="5" step="0.005"
                                              label=""
                                              v-model="template.objects[active_object].scale"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group">
                                        <label for="control3" class="control-label label-checkbox mb10">По центру по горизонтали</label>
                                        <input @change="setObjectPosition(0.5, null)"
                                               :checked="template.objects[active_object].position_x == 0.5"
                                               id="control3" class="form-check-inline"
                                               type="checkbox">
                                        <div class="clearfix"></div>
                                        <label for="control4" class="control-label label-checkbox mb10">По центру по вертикали</label>
                                        <input @change="setObjectPosition(null, 0.5)"
                                               :checked="template.objects[active_object].position_y == 0.5"
                                               id="control4" class="form-check-inline"
                                               type="checkbox">
                                    </div>
                                    <fg-input type="text"
                                              label="Поворот объекта (градусы)"
                                              v-model="template.objects[active_object].angle"
                                              placeholder="">
                                    </fg-input>
                                    <div class="form-group" v-show="template.objects[active_object].id.indexOf('nocolor') < 0">
                                        <label class="control-label">Цвет: <span class="param-span">{{
                                                template.objects[active_object].color
                                            }}</span></label>
                                        <input type="color" v-model="template.objects[active_object].color">
                                        <div class="color-set">
                                            <span v-for="c in colors" :style="{ backgroundColor: c }"
                                                  :class="{ 'active' : c === template.objects[active_object].color}"
                                                  @click="setObjColor(c)"></span>
                                        </div>
                                    </div>

                                    <div class="form-group">
                                        <label class="control-label">Анимация</label>
                                        <select v-model="template.objects[active_object].animation_type"
                                                id="category-control"
                                                aria-describedby="addon-right addon-left"
                                                class="form-control">
                                            <option v-for="t in animation_types" v-bind:value="t.id">{{ t.name }}</option>
                                        </select>
                                    </div>
                                    <label v-show="template.objects[active_object].animation_type !== 0"
                                           class="control-label" >Длительность анимации: <span
                                        class="param-span">{{ template.objects[active_object].animation_duration }}</span></label>
                                    <fg-input v-show="template.objects[active_object].animation_type !== 0" type="range"
                                              min="0" max="1.5" step="0.1"
                                              label=""
                                              v-model="template.objects[active_object].animation_duration"
                                              placeholder="">
                                    </fg-input>

                                    <label class="control-label">Видимость: <span
                                        class="param-span">{{ template.objects[active_object].alpha }}</span></label>
                                    <fg-input type="range"
                                              min="0" max="1" step="0.01"
                                              label=""
                                              v-model="template.objects[active_object].alpha"
                                              placeholder="">
                                    </fg-input>

                                    <fg-input type="text"
                                              label="Z-индекс"
                                              v-model="template.objects[active_object].z_index"
                                              placeholder="">
                                    </fg-input>

                                    <button type="button" class="btn btn-remove"
                                            @click="removeObject(active_object)">Удалить объект
                                    </button>
                                    <div class="clearfix"></div>

                                </div>

                                <div class="col-md-8">
                                    <div id="preview-container" v-if="template">
                                        <div id="player" v-show="template.src_full">
                                            <video ref="videoContainer" v-if="!isVideo(template.preview_src_full)"
                                                   controls disablepictureinpicture
                                                   muted
                                                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                                   playsinline id="video_player"
                                                   v-bind:poster="template.preview_src_full"
                                                   style="max-width: 100%; cursor: pointer;">
                                                <source v-bind:src="template.src_full"/>
                                            </video>
                                            <video ref="videoContainer" v-if="isVideo(template.preview_src_full)"
                                                   controls disablepictureinpicture
                                                   muted
                                                   controlsList="nofullscreen nodownload noremoteplayback noplaybackrate"
                                                   playsinline id="video_player2"
                                                   style="max-width: 100%; cursor: pointer;">
                                                <source v-bind:src="template.src_full"/>
                                            </video>
                                            <div v-for="(tt, index) in template.texts"
                                                 ref="draggableContainer" class="draggable-container"
                                                 v-if="tt.font_size"
                                                 v-bind:id="`${index}`">
                                                <div v-show="tt.is_visible === 1" class="draggable-header"
                                                     v-html="text_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                            <div v-for="(tt, index) in template.objects"
                                                 ref="draggableContainer2" class="draggable-container" v-if="tt.scale"
                                                 v-bind:id="`o${index}`">
                                                <div v-show="tt.is_visible === 1" class="draggable-header nospace"
                                                     v-html="object_html(index)" @mousedown="dragMouseDown">
                                                </div>
                                            </div>
                                        </div>

                                        <button type="button" class="btn btn-toggle"
                                                v-bind:class="{ 'active-state': template.src_full }"
                                                @click.prevent="showPreview()">
                                            Показать превью
                                        </button>
                                    </div>

                                </div>


                            </div>

                            <div class="clearfix"></div>
                        </form>
                    </card>
                </div>
                <div class="col-md-3">
                    <card>
                        <h4 slot="header" class="card-title">Параметры видео</h4>
                        <div class="loader" v-if="waiting"></div>
                        <form v-if="template">
                            <div class="row">

                                <div class="col-md-12">
                                    <fg-input type="text"
                                              @input="formatVideoDuration($event)"
                                              label="Длительность, сек."
                                              v-model="template.duration"
                                              placeholder="">
                                    </fg-input>
                                    <fg-input type="text"
                                              label="Количество фрагментов"
                                              @input="changeVideoCount"
                                              v-model="template.videos"
                                              placeholder="">
                                    </fg-input>
                                    <h4 slot="header" class="card-title">Фрагменты:
                                    </h4>


                                    <div class="content" v-for="(itm,index) in client_parts" :key="index">
                                        <div class="control">
                                            <div class="row">
                                                <div class="col-md-5">
                                                    <fg-input type="text"
                                                              @input="formatDuration($event, index)"
                                                              v-bind:label="`#` + String(index + 1) + ` - длительность`"
                                                              v-model="client_parts[index].duration"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-3">
                                                    <fg-input type="text"
                                                              @input="formatSpeed($event, index)"
                                                              v-bind:label="`Скорость`"
                                                              v-model="client_parts[index].speed"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Эффект</label>
                                                        <select v-model="client_parts[index].effect_type"
                                                                @change="changeEffectType(index, client_parts[index].effect_type)"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="e in effect_types" v-bind:value="e.id">{{ e.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row bordered">
                                                <div class="col-md-4">
                                                    <div class="form-group">
                                                        <label class="control-label">Коллаж</label>
                                                        <select v-model="client_parts[index].collage_type"
                                                                @change="changeCollageType(index, client_parts[index].collage_type)"
                                                                id="category-control"
                                                                aria-describedby="addon-right addon-left"
                                                                class="form-control">
                                                            <option v-for="e in collage_types" v-bind:value="e.id">{{ e.name }}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="col-md-5" v-if="client_parts[index].collage_type">
                                                    <fg-input type="text"
                                                              @input="formatStartTime($event, index)"
                                                              v-bind:label="`Время начала`"
                                                              v-model="client_parts[index].start_time"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>
                                            <div class="row" v-if="client_parts[index].effect_type !== 0 && client_parts[index].effect_values">
                                                <div class="effect-values">{{ effect_types[client_parts[index].effect_type].name }} - Параметры</div>
                                                <div class="col-md-3">
                                                    <div class="effect-preview" @click="changeEffectPosition($event, index)">
                                                        <span class="effect-area"
                                                              :style="{'top': client_parts[index].effect_values.y * 87 - 15 + 'px',
                                                                        'left': client_parts[index].effect_values.x * 48 - 15 + 'px'}">
                                                            <span class="effect-center"></span>
                                                        </span>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`#` + String(index + 1) + ` - Начальное значение`"
                                                              v-model="client_parts[index].effect_values.from"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                                <div class="col-md-3">
                                                    <fg-input type="number" step=0.1
                                                              v-bind:label="`#` + String(index + 1) + ` - Конечное значение`"
                                                              v-model="client_parts[index].effect_values.to"
                                                              placeholder="">
                                                    </fg-input>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>


                            </div>


                        </form>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'

const _ = require('lodash')

const moment = require('moment')
import Card from 'src/components/UIComponents/Cards/Card.vue'
import {template} from "lodash";

export default {
    name: 'EditCategory',
    components: {
        Card,
    },
    data() {
        return {
            id: null,
            showP: false,
            token: localStorage.getItem('token'),
            template: null,
            activeVideo: '',
            waiting: false,
            interval: null,
            lock_waiting: false,
            is_playing: false,
            show_svg_modal: false,
            is_object_changing: false,
            video: null,
            categories: JSON.parse(localStorage.getItem('categories')),
            sizes: JSON.parse(localStorage.getItem('sizes')),
            compression: false,
            preview: null,
            source: null,
            client_parts: [],
            is_text_active: false,
            active_text: 0,
            active_object: 0,
            draggable_index: 0,
            draggable_type: null,
            active_type: 'text',
            svg_list: [],
            active_object_category: 'arrows',
            default_text: {
                text: 'Default text',
                font_name: 'SF Pro',
                font_size: 30,
                text_color: "#ffffff",
                letter_spacing: 0,
                line_spacing: 0,
                alpha: 1,
                text_align: 'center',
                background_color: 'transparent',
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
                direction: 'normal',
                shadow_blur: 0,
                shadow_alpha: 0,
                animation_type: 0,
                animation_duration: 0,
                shadow_color: '#ffffff',
                stroke_size: 0,
                stroke_color: '#000000',
            },
            default_object: {
                id: "b-330x298.svg",
                scale: 1,
                source: '<span>SVG</span>',
                color: '#ffffff',
                alpha: 1,
                position_x: 0.49,
                position_y: 0.49,
                z_index: 1,
                animation_type: 0,
                animation_duration: 0,
                time_start: 0,
                time_end: "",
                is_visible: 1,
                angle: 0,
            },
            texts: [],
            objects: [],
            colors: [
                "#FFFFFF",
                "#000000",
                "#F9F7F4",
                "#FAF5ED",
                "#F2E8DD",
                "#F4E4DD",
                "#D9BEBD",
                "#C5AEB6",
                "#E3C2D2",
                "#F1E0EF",
                "#D5C9E9",
                "#C8ACE0",
                "#E06E97",
                "#E64F3C",
                "#AB613E",
                "#B97959",
                "#D99056",
                "#E8BF88",
                "#EDD8AB",
                "#FAE389",
                "#F5C154",
                "#B78C3A",
                "#585B3B",
                "#7B7C41",
                "#BBB595",
                "#DFE7DA",
                "#C0DED3",
                "#B4C5C9",
                "#C9D9F0",
                "#4E63EC",
                "#4F5E8D",
                "#725B6E",
                "#F0F0F0",
                "#D9D9D9",
                "#616161",
                "#3C3C3C",
            ],
            fonts: [
                {
                    params: "'SF Pro', sans-serif;",
                    code: "SF Pro",
                    name: "SF Pro",
                },
                {
                    params: "'Amsterdam Four', sans-serif;",
                    code: "Amsterdam Four",
                    name: "Amsterdam Four",
                },
                {
                    params: "'Bodoni 72', sans-serif;",
                    code: "Bodoni 72",
                    name: "Bodoni 72",
                },
                {
                    params: "'Courier New', sans-serif;",
                    code: "Courier New",
                    name: "Courier New",
                },
                {
                    params: "'Didot', sans-serif;",
                    code: "Didot",
                    name: "Didot",
                },
                {
                    params: "'Menlo', sans-serif;",
                    code: "Menlo",
                    name: "Menlo",
                },
                {
                    params: "'Optima', sans-serif;",
                    code: "Optima",
                    name: "Optima",
                },
                {
                    params: "'Copperplate Gothic Light', sans-serif;",
                    code: "Copperplate Gothic Light",
                    name: "Copperplate",
                },
                {
                    params: "'Avenir', sans-serif;",
                    code: "Avenir",
                    name: "Avenir",
                },
                {
                    params: "'AmaticSC-Bold', sans-serif;",
                    code: "AmaticSC-Bold",
                    name: "Amatic SC",
                },
                {
                    params: "'Zapfino', sans-serif;",
                    code: "Zapfino",
                    name: "Zapfino",
                },
                {
                    params: "'BebasNeue-Regular', sans-serif;",
                    code: "BebasNeue-Regular",
                    name: "Bebas Neue",
                },
                {
                    params: "'Noteworthy', sans-serif;",
                    code: "Noteworthy",
                    name: "Noteworthy",
                },
                {
                    params: "'DancingScript-Bold', sans-serif;",
                    code: "DancingScript-Bold",
                    name: "Dancing Script",
                },
                {
                    params: "'Chilanka-Regular', sans-serif;",
                    code: "Chilanka-Regular",
                    name: "Chilanka",
                },
                {
                    params: "'Intro', sans-serif;",
                    code: "Intro",
                    name: "Intro",
                },
                {
                    params: "'Futura', sans-serif;",
                    code: "Futura",
                    name: "Futura",
                },
                {
                    params: "'JosefinSans-Bold', sans-serif;",
                    code: "JosefinSans-Bold",
                    name: "Josefin Sans",
                },
                {
                    params: "'Kalam-Bold', sans-serif;",
                    code: "Kalam-Bold",
                    name: "Kalam",
                },
                {
                    params: "'Lato-Regular', sans-serif;",
                    code: "Lato-Regular",
                    name: "Lato",
                },
                {
                    params: "'Lobster-Regular', sans-serif;",
                    code: "Lobster-Regular",
                    name: "Lobster",
                },
                {
                    params: "'Raleway-Bold', sans-serif;",
                    code: "Raleway-Bold",
                    name: "Raleway",
                },
                {
                    params: "'Bentoga', sans-serif;",
                    code: "Bentoga-Thin",
                    name: "Bentoga",
                },
                {
                    params: "'Brusher', sans-serif;",
                    code: "Brusher",
                    name: "Brusher",
                },
                {
                    params: "'Calistoga', sans-serif;",
                    code: "Calistoga-Regular",
                    name: "Calistoga",
                },
                {
                    params: "'Fondamento', sans-serif;",
                    code: "Fondamento-Regular",
                    name: "Fondamento",
                },
                {
                    params: "'Savoye LET', sans-serif;",
                    code: "Savoye LET",
                    name: "Savoye LET",
                },
                {
                    params: "'Homemade Apple', sans-serif;",
                    code: "HomemadeApple-Regular",
                    name: "Homemade Apple",
                },
                {
                    params: "'Luna', sans-serif;",
                    code: "Luna",
                    name: "Luna",
                },
                {
                    params: "'NewYork', sans-serif;",
                    code: "NewYork",
                    name: "NewYork",
                },
                {
                    params: "'Pathway Gothic', sans-serif;",
                    code: "PathwayGothicOne-Regular",
                    name: "Pathway Gothic",
                },
                {
                    params: "'Quattrocento', sans-serif;",
                    code: "Quattrocento-Bold",
                    name: "Quattrocento",
                },
                {
                    params: "'Syne', sans-serif;",
                    code: "Syne-Bold",
                    name: "Syne",
                },
                {
                    params: "'Thesignature', sans-serif;",
                    code: "Thesignature",
                    name: "Thesignature",
                },
                {
                    params: "'Tuesday Night', sans-serif;",
                    code: "TuesdayNight-Regular",
                    name: "Tuesday Night",
                },
                {
                    params: "'Yellowtail', sans-serif;",
                    code: "Yellowtail-Regular",
                    name: "Yellowtail",
                },
                {
                    params: "'Aegean', sans-serif;",
                    code: "Aegean",
                    name: "Aegean",
                },
                {
                    params: "'ALTA', sans-serif;",
                    code: "Alta_regular",
                    name: "ALTA",
                },
                {
                    params: "'Baskerville', sans-serif;",
                    code: "Baskerville",
                    name: "Baskerville",
                },
                {
                    params: "'Belleza', sans-serif;",
                    code: "Belleza",
                    name: "Belleza",
                },
                {
                    params: "'Black Mango', sans-serif;",
                    code: "Black Mango",
                    name: "Black Mango",
                },
                {
                    params: "'Catchy Mager', sans-serif;",
                    code: "Catchy Mager",
                    name: "Catchy Mager",
                },
                {
                    params: "'Hatton', sans-serif;",
                    code: "Hatton",
                    name: "Hatton",
                },
                {
                    params: "'HUOVA', sans-serif;",
                    code: "HUOVA",
                    name: "HUOVA",
                },
                {
                    params: "'Kudryashev', sans-serif;",
                    code: "Kudryashev",
                    name: "Kudryashev",
                },
                {
                    params: "'Laguna', sans-serif;",
                    code: "Laguna",
                    name: "Laguna",
                },
                {
                    params: "'Liana', sans-serif;",
                    code: "Liana",
                    name: "Liana",
                },
                {
                    params: "'Lovelace', sans-serif;",
                    code: "Lovelace",
                    name: "Lovelace",
                },
                {
                    params: "'Lovelo', sans-serif;",
                    code: "Lovelo",
                    name: "Lovelo",
                },
                {
                    params: "'Mak', sans-serif;",
                    code: "Mak",
                    name: "Mak",
                },
                {
                    params: "'Maragsa', sans-serif;",
                    code: "Maragsa",
                    name: "Maragsa",
                },
                {
                    params: "'Tan Pearl', sans-serif;",
                    code: "Tan Pearl",
                    name: "Tan Pearl",
                },
                {
                    params: "'Tenor', sans-serif;",
                    code: "Tenor",
                    name: "Tenor",
                },
                {
                    params: "'The Seasons', sans-serif;",
                    code: "The Seasons",
                    name: "The Seasons",
                },
                {
                    params: "'Allura', sans-serif;",
                    code: "Allura",
                    name: "Allura",
                },
                {
                    params: "'Alyssum', sans-serif;",
                    code: "Alyssum",
                    name: "Alyssum",
                },
                {
                    params: "'Bangers', sans-serif;",
                    code: "Bangers",
                    name: "Bangers",
                },
                {
                    params: "'Boulder', sans-serif;",
                    code: "Boulder",
                    name: "Boulder",
                },
                {
                    params: "'Carlson', sans-serif;",
                    code: "Carlson",
                    name: "Carlson",
                },
                {
                    params: "'Hello January', sans-serif;",
                    code: "Hello January",
                    name: "Hello January",
                },
                {
                    params: "'Hit and Run', sans-serif;",
                    code: "Hit and Run",
                    name: "Hit and Run",
                },
                {
                    params: "'Horta', sans-serif;",
                    code: "Horta",
                    name: "Horta",
                },
                {
                    params: "'Knewave', sans-serif;",
                    code: "Knewave",
                    name: "Knewave",
                },
                {
                    params: "'Lovelies', sans-serif;",
                    code: "Lovelies",
                    name: "Lovelies",
                },
                {
                    params: "'Monoton', sans-serif;",
                    code: "Monoton",
                    name: "Monoton",
                },
                {
                    params: "'Party Confetti', sans-serif;",
                    code: "Party Confetti",
                    name: "Party Confetti",
                },
                {
                    params: "'Peace', sans-serif;",
                    code: "Peace",
                    name: "Peace",
                },
                {
                    params: "'Petit Cochon', sans-serif;",
                    code: "Petit Cochon",
                    name: "Petit Cochon",
                },
                {
                    params: "'Playlist', sans-serif;",
                    code: "Playlist",
                    name: "Playlist",
                },
                {
                    params: "'Pushkin', sans-serif;",
                    code: "Pushkin",
                    name: "Pushkin",
                },
                {
                    params: "'Sarina', sans-serif;",
                    code: "Sarina",
                    name: "Sarina",
                },
                {
                    params: "'Shrikhand', sans-serif;",
                    code: "Shrikhand",
                    name: "Shrikhand",
                },
                {
                    params: "'Studly', sans-serif;",
                    code: "Studly",
                    name: "Studly",
                },
                {
                    params: "'The Youngest', sans-serif;",
                    code: "The Youngest",
                    name: "The Youngest",
                },
                {
                    params: "'Amsterdam One', sans-serif;",
                    code: "Amsterdam One",
                    name: "Amsterdam One",
                },
                {
                    params: "'Brittany', sans-serif;",
                    code: "Brittany",
                    name: "Brittany",
                },
                {
                    params: "'Daydream', sans-serif;",
                    code: "Daydream",
                    name: "Daydream",
                },
                {
                    params: "'Inters', sans-serif;",
                    code: "Inters",
                    name: "Inters",
                },
                {
                    params: "'Kavivanar', sans-serif;",
                    code: "Kavivanar",
                    name: "Kavivanar",
                },
                {
                    params: "'Mixa', sans-serif;",
                    code: "Mixa",
                    name: "Mixa",
                },
                {
                    params: "'Sisterhood', sans-serif;",
                    code: "Sisterhood",
                    name: "Sisterhood",
                },
                {
                    params: "'Virtual', sans-serif;",
                    code: "Virtual",
                    name: "Virtual",
                },
                {
                    params: "'Anton', sans-serif;",
                    code: "Anton",
                    name: "Anton",
                },
                {
                    params: "'Blue-Ocean', sans-serif;",
                    code: "Blue Ocean",
                    name: "Blue Ocean",
                },
                {
                    params: "'Cormorant', sans-serif;",
                    code: "Cormorant",
                    name: "Cormorant",
                },
                {
                    params: "'Culture', sans-serif;",
                    code: "Culture",
                    name: "Culture",
                },
                {
                    params: "'Keep-on-Truckin', sans-serif;",
                    code: "Keep on Truckin",
                    name: "Keep on Truckin",
                },
                {
                    params: "'Kingthings', sans-serif;",
                    code: "Kingthings",
                    name: "Kingthings",
                },
                {
                    params: "'Maharlika', sans-serif;",
                    code: "Maharlika",
                    name: "Maharlika",
                },
                {
                    params: "'Montserrat', sans-serif;",
                    code: "Montserrat",
                    name: "Montserrat",
                },
                {
                    params: "'Nectarine', sans-serif;",
                    code: "Nectarine",
                    name: "Nectarine",
                },
                {
                    params: "'Sandy', sans-serif;",
                    code: "Sandy",
                    name: "Sandy",
                },
                {
                    params: "'Tan-Paradiso', sans-serif;",
                    code: "Tan-Paradiso",
                    name: "Tan-Paradiso",
                },
                {
                    params: "'Well-Cake', sans-serif;",
                    code: "Well-Cake",
                    name: "Well-Cake",
                },
                {
                    params: "'Agrandir', sans-serif;",
                    code: "Agrandir",
                    name: "Agrandir",
                },
                {
                    params: "'BlackGold', sans-serif;",
                    code: "BlackGold",
                    name: "BlackGold",
                },
                {
                    params: "'Bright', sans-serif;",
                    code: "Bright",
                    name: "Bright",
                },
                {
                    params: "'Brown Sugar', sans-serif;",
                    code: "Brown Sugar",
                    name: "Brown Sugar",
                },
                {
                    params: "'Garet', sans-serif;",
                    code: "Garet",
                    name: "Garet",
                },
                {
                    params: "'Harmony', sans-serif;",
                    code: "Harmony",
                    name: "Harmony",
                },
                {
                    params: "'Migra', sans-serif;",
                    code: "Migra",
                    name: "Migra",
                },
                {
                    params: "'Migra Italic', sans-serif;",
                    code: "Migra Italic",
                    name: "Migra Italic",
                },
                {
                    params: "'Noto Serif Display', sans-serif;",
                    code: "Noto Serif Display",
                    name: "Noto Serif Display",
                },
                {
                    params: "'Pinyon Script', sans-serif;",
                    code: "Pinyon Script",
                    name: "Pinyon Script",
                },
                {
                    params: "'Sloop Script', sans-serif;",
                    code: "Sloop Script",
                    name: "Sloop Script",
                },
                {
                    params: "'Redkits', sans-serif;",
                    code: "Redkits",
                    name: "Redkits",
                },
                {
                    params: "'Sceageus', sans-serif;",
                    code: "Sceageus",
                    name: "Sceageus",
                },
                {
                    params: "'Tan Nimbus', sans-serif;",
                    code: "Tan Nimbus",
                    name: "Tan Nimbus",
                },
                {
                    params: "'Kenao', sans-serif;",
                    code: "Kenao",
                    name: "Kenao",
                },

            ],
            animation_types: [
                {
                    id: 0,
                    name: "Без анимации",
                },
                {
                    id: 1,
                    name: "Fade",
                },
                {
                    id: 4,
                    name: "Scale",
                },
                {
                    id: 6,
                    name: "Reveal ↓",
                },
                {
                    id: 7,
                    name: "Reveal ↑",
                },
                {
                    id: 8,
                    name: "Reveal →",
                },
                {
                    id: 9,
                    name: "Reveal ←",
                },
                {
                    id: 10,
                    name: "Float ↓",
                },
                {
                    id: 11,
                    name: "Float ↑",
                },
                {
                    id: 12,
                    name: "Float →",
                },
                {
                    id: 13,
                    name: "Float ←",
                },
                {
                    id: 14,
                    name: "Typewriter",
                },
            ],
            effect_types: [
                {
                    id: 0,
                    name: "-",
                },
                {
                    id: 1,
                    name: "Zoom in",
                },
                {
                    id: 2,
                    name: "Zoom out",
                },
            ],
            collage_types: [
                {
                    id: 0,
                    name: "-",
                    params: null,
                },
                {
                    id: 1,
                    name: "1/4",
                    params: {x: 0, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 2,
                    name: "2/4",
                    params: {x: 0.5, y: 0, w: 0.5, h: 0.5},
                },
                {
                    id: 3,
                    name: "3/4",
                    params: {x: 0, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 4,
                    name: "4/4",
                    params: {x: 0.5, y: 0.5, w: 0.5, h: 0.5},
                },
                {
                    id: 5,
                    name: "1/3",
                    params: {x: 0, y: 0, w: 1, h: 0.3333},
                },
                {
                    id: 6,
                    name: "2/3",
                    params: {x: 0, y: 0.3333, w: 1, h: 0.3333}
                },
                {
                    id: 7,
                    name: "3/3",
                    params: {x: 0, y: 0.6666, w: 1, h: 0.3333}
                },
                {
                    id: 8,
                    name: "1/2",
                    params: {x: 0, y: 0, w: 1, h: 0.5}
                },
                {
                    id: 9,
                    name: "2/2",
                    params: {x: 0, y: 0.5, w: 1, h: 0.5}
                },
            ],
            text_aligns: [
                {
                    name: "center",
                },
                {
                    name: "start",
                },
                {
                    name: "end",
                },

            ],
            default_positions: {
                clientX: undefined,
                clientY: undefined,
                movementX: 0,
                movementY: 0
            },
            positions: [],
            object_positions: []
        }
    },
    watch: {
        is_playing(val) {
            if (val) {
                this.startInterval()
            } else {
                clearInterval(this.interval);
            }
        },
    },
    created: function () {
        let self = this;
        self.id = this.$route.params.id;

        // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
        let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

        let open = indexedDB.open("MuseDatabase");

        open.onupgradeneeded = function() {
            let db = open.result;
            let store = db.createObjectStore("MuseObjectStore", {keyPath: "id"});
        };

        open.onsuccess = function() {
            // Start a new transaction
            let db = open.result;
            let tx = db.transaction("MuseObjectStore", "readwrite");
            let store = tx.objectStore("MuseObjectStore");
            let data = store.get(self.$storeVersion);

            data.onsuccess = function() {
                console.log(data.result);
                if (!data.result) {
                    self.getSVG();
                } else {
                    self.svg_list = data.result.object;
                    self.get(self.id);
                }

            };

            // Close the db when the transaction is done
            tx.oncomplete = function() {
                db.close();
            };
        }

        open.onerror = function(error) {
            console.log(error);
        }
    },
    computed: {
        sumParts() {
            let sum = 0;
            _.map(this.client_parts, (p) => {
                if (isNaN(parseFloat(p.duration))) {
                    sum += 0;
                } else {
                    sum += parseFloat(p.duration);
                }
            })

            return sum.toFixed(2);
        },
        sortedFonts() {
            return _.sortBy(this.fonts, (f) => {
                return f.name;
            });
        }
    },
    methods: {
        text_html(index) {
            let textModel = this.template.texts[index];

            let text = _.find(this.fonts, (f) => f.name === textModel.font_name);

            let line_height = parseFloat(textModel.font_size) + parseFloat(textModel.line_spacing);
            let alpha = textModel.alpha;

            let direction = '';
            if (textModel.direction === 'vertical') {
                direction = '  writing-mode: vertical-rl;\n' +
                    '  text-orientation: upright;\n'
            }

            let offset = 4 / 88 * textModel.font_size;
            let blur = 0.29 * textModel.font_size / 88 * textModel.shadow_blur;
            let shadow = `text-shadow: ${offset}px ${offset}px ${blur}px ${textModel.shadow_color}${this.convertAlphaToHex(textModel.shadow_alpha)};`;

            return '<span style="color: ' + textModel.text_color + '; ' +
                'background-color: ' + textModel.background_color + '; ' +
                'font-size: ' + textModel.font_size + 'px; ' +
                'letter-spacing: ' + textModel.letter_spacing + 'px; ' +
                'opacity: ' + alpha + '; ' +
                'line-height: ' + line_height + 'px; ' +
                'transform: rotate( ' + textModel.angle + 'deg); ' +
                'display: block;' +
                'border: 1px solid white;' +
                'padding: 5px;' +
                direction +
                shadow +
                'text-align: ' + textModel.text_align + '; ' +
                'z-index: ' + textModel.z_index + '; ' +
                'font-family:' + text.params + ';">'
                + textModel.text + '</span>';

        },
        object_html(index) {
            let objectModel = this.template.objects[index];

            if (!objectModel.source) {
                return "";
            }

            let source = objectModel.source;

            let width = 100;
            let height = 100;
            let w = source.match(/width="\d{1,5}"/);
            let h = source.match(/height="\d{1,5}"/);
            if (w && h) {
                width = w[0].split('"')[1];
                height = h[0].split('"')[1];
            }

            width = width * parseFloat(objectModel.scale);
            height = height * parseFloat(objectModel.scale);

            source = source.replace(/width="\d{1,4}"/, `width="${width}"`);
            source = source.replace(/height="\d{1,4}"/, `height="${height}"`);
            source = source.replace(/fill="black"/g, `fill="${objectModel.color}"`);
            source = source.replace(/stroke="black"/g, `stroke="${objectModel.color}"`);

            let style = ` style="opacity: ${objectModel.alpha}; border: 1px solid white; padding: 0px; transform: rotate(${objectModel.angle}deg); z-index: ${objectModel.z_index}"`;

            source = this.insertAt(source, style, 5)

            return source;

        },
        isVideo: function (url) {
            return url.indexOf('.mp4') > -1;
        },
        goBack: function () {
            window.history.back();
        },
        insertAt(str, sub, pos) {
            return `${str.slice(0, pos)}${sub}${str.slice(pos)}`;
        },
        formatStartTime(event, index) {
            this.client_parts[index].start_time = this.client_parts[index].start_time.replace(',', '.')
        },
        formatDuration(event, index) {
            this.client_parts[index].duration = this.client_parts[index].duration.replace(',', '.')
        },
        formatSpeed(event, index) {
            this.client_parts[index].speed = this.client_parts[index].speed.replace(',', '.')
        },
        formatVideoDuration(event, index) {
            this.template.duration = this.template.duration.replace(',', '.')
        },
        addText(copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedText = JSON.parse(JSON.stringify(self.template.texts[self.active_text]));
                copiedText.text = 'Default text';

                self.template.texts.push(copiedText);

                let positions = self.positions[self.active_text];
                positions.clientX = positions.clientX ? positions.clientX + 5 : positions.clientX;
                positions.clientY = positions.clientY ? positions.clientY + 5 : positions.clientY;
                self.positions.push(JSON.parse(JSON.stringify(positions)));

                setTimeout(() => {

                    self.$refs.draggableContainer[self.template.texts.length - 1].style.left = self.$refs.draggableContainer[self.active_text].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = self.$refs.draggableContainer[self.active_text].offsetTop + 5 + 'px';

                    self.active_text = self.template.texts.length - 1;
                    self.active_type = 'text';

                    //console.log(self.$refs.draggableContainer[self.template.texts.length - 1].style.left);
                }, 100);
            } else {
                self.template.texts.push(JSON.parse(JSON.stringify(self.default_text)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                self.active_text = self.template.texts.length - 1;
                self.active_type = 'text';

            }

        },
        addObject(object, copy = false) {
            let self = this;

            // if copied
            if (copy !== false) {
                let copiedObject = JSON.parse(JSON.stringify(self.template.objects[self.active_object]));

                self.template.objects.push(copiedObject);
                self.object_positions.push(JSON.parse(JSON.stringify(self.object_positions[self.active_object])));

                setTimeout(() => {

                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.left = self.$refs.draggableContainer2[self.active_object].offsetLeft + 5 + 'px';
                    self.$refs.draggableContainer2[self.template.objects.length - 1].style.top = self.$refs.draggableContainer2[self.active_object].offsetTop + 5 + 'px';

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object'

                }, 100);
            } else {

                if (self.is_object_changing) {
                    let obj = self.template.objects[self.active_object];
                    obj.id = object.id;
                    obj.source = object.source;
                    obj.category = object.category;
                } else {
                    let newObj = JSON.parse(JSON.stringify(self.default_object));
                    newObj.id = object.id;
                    newObj.source = object.source;
                    newObj.category = object.category;
                    self.template.objects.push(newObj);
                    self.object_positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                    self.active_object = self.template.objects.length - 1;
                    self.active_type = 'object';
                }

                self.is_object_changing = false;
                self.show_svg_modal = false;
            }

            self.active_object_category = 'arrows';

        },
        changeObject() {
            this.is_object_changing = true;
            this.show_svg_modal = true;
        },
        convertAlphaToHex(alpha) {
            if (alpha < 0.08) return '00';
            return Math.floor(alpha * 255).toString(16);
        },
        selectText(text) {
            this.active_text = text;
            this.active_type = 'text';
        },
        selectObject(object) {
            this.active_object = object;
            this.active_type = 'object';
        },
        selectObjectCategory(category) {
            this.active_object_category = category;
        },
        removeText(index) {
            let self = this;

            if (self.template.texts.length < 2) {
                const notification = {
                    template: `<span><b>Для удаления последнего текста используйте чекбокс "Наложение текста"</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'warning'
                    })

                return;
            }

            if (confirm("Подтверждение удаление текста: " + self.template.texts[index].text)) {
                self.active_text = 0;
                self.active_type = 'text'

                self.template.texts = self.template.texts.filter((t, i) => i !== index);
            }
        },
        removeObject(index) {
            let self = this;

            if (self.template.objects.length < 2) {
                const notification = {
                    template: `<span><b>Для удаления последнего объекта используйте чекбокс "Наложение текста"</b></span>`
                };

                self.$notifications.notify(
                    {
                        component: notification,
                        icon: 'nc-icon nc-simple-remove',
                        horizontalAlign: 'right',
                        verticalAlign: 'top',
                        type: 'warning'
                    })

                return;
            }

            if (confirm("Подтверждение удаление объекта")) {
                self.active_object = 0;
                self.active_type = 'object'

                self.template.objects = self.template.objects.filter((t, i) => i !== index);
            }
        },
        toggleText() {
            let self = this;

            if (self.is_text_active) {
                self.template.texts.push(JSON.parse(JSON.stringify(self.default_text)));
                self.positions.push(JSON.parse(JSON.stringify(self.default_positions)));

                setTimeout(() => {
                    self.$refs.draggableContainer[self.template.texts.length - 1].style.top = '0px';

                    self.video = self.$refs.videoContainer;

                    self.video.addEventListener("playing", function () {
                        //console.log('play ' + self.video.currentTime);

                        self.is_playing = true;
                    });

                    self.video.addEventListener("timeupdate", function () {
                        self.checkElementsVisibility(self.video.currentTime);
                    });

                    self.video.addEventListener("pause", function () {
                        //console.log('pause ' + self.video.currentTime);

                        self.is_playing = false;
                    });

                }, 500);
            } else {
                self.template.texts = [];
                self.positions = [];
            }
        },
        toggleBackground() {
            if (this.template.texts[this.active_text].background_color === 'transparent') {
                this.setColor('#FFFFFF', 'background');
            } else {
                this.setColor('transparent', 'background');
            }
        },
        setTextPosition: function (x, y) {
            if (x) {
                this.template.texts[this.active_text].position_x = x;

                let centerX = 0.5 * 360 - this.$refs.draggableContainer[this.active_text].clientWidth / 2;

                this.$refs.draggableContainer[this.active_text].style.left = centerX + 'px';
            }

            if (y) {
                this.template.texts[this.active_text].position_y = y;

                let centerY = 0.5 * 640 - this.$refs.draggableContainer[this.active_text].clientHeight / 2;

                this.$refs.draggableContainer[this.active_text].style.top = centerY + 'px';
            }
        },
        setObjectPosition: function (x, y) {
            if (x) {
                this.template.objects[this.active_object].position_x = x;

                let centerX = 0.5 * 360 - this.$refs.draggableContainer2[this.active_object].clientWidth / 2;

                this.$refs.draggableContainer2[this.active_object].style.left = centerX + 'px';
            }

            if (y) {
                this.template.objects[this.active_object].position_y = y;

                let centerY = 0.5 * 640 - this.$refs.draggableContainer2[this.active_object].clientHeight / 2;

                this.$refs.draggableContainer2[this.active_object].style.top = centerY + 'px';
            }
        },
        changeEffectType: function(index, type) {

            if (type === 0) {
                return;
            }

            let from = 1;
            let to = 0.85;
            if (type === 2) {
                from = 0.85;
                to = 1;
            }

            this.client_parts[index].effect_values = {
                from: from,
                to: to,
                x: 0.5,
                y: 0.5
            }

        },
        changeCollageType: function(index, type) {

            if (type === 0) {
                this.client_parts[index].frame = null;
                return;
            }

            this.client_parts[index].frame = _.find(this.collage_types, (c) => c.id === type).params;
        },
        changeEffectPosition: function(event, index) {
            let offsetX;
            let offsetY;

            if (event.target.className !== 'effect-preview') {
                let parent = event.target.parentElement;
                if (parent.className !== 'effect-preview') {
                    parent = parent.parentElement;

                } else {

                }

                offsetX = 0;
                offsetY = 0;
            } else {
                offsetX = event.offsetX < 0 ? 0 : event.offsetX;
                offsetY = event.offsetY < 0 ? 0 : event.offsetY;
            }

            this.client_parts[index].effect_values.x = (offsetX / 50).toFixed(2);
            if (this.client_parts[index].effect_values.x > 1) {
                this.client_parts[index].effect_values.x = 1;
            }

            this.client_parts[index].effect_values.y = (offsetY / 89).toFixed(2);
            if (this.client_parts[index].effect_values.y > 1) {
                this.client_parts[index].effect_values.y = 1;
            }
        },
        setColor: function (color, type) {
            if (type === 'color') {
                this.template.texts[this.active_text].text_color = color;
            }

            if (type === 'background') {
                this.template.texts[this.active_text].background_color = color;
            }
        },
        setObjColor: function (color) {
            this.template.objects[this.active_object].color = color;
        },
        changeVideoCount(value) {
            let self = this;
            let oldParts = JSON.parse(JSON.stringify(self.client_parts));

            if (isNaN(parseInt(value))) {
                return oldParts;
            }

            let newParts = [];
            for (let i = 0; i < value; i++) {
                newParts.push({
                    duration: '',
                    speed: '1.0',
                    effect_type: 0,
                    effect_values: {x: 0.5, y: 0.5},
                    collage_type: 0,
                    frame: 0,
                    start_time: 0
                })
            }

            for (let i = 0; i < oldParts.length; i++) {
                for (let j = 0; j < newParts.length; j++) {
                    if (i === j) {
                        newParts[j] = oldParts[i];
                    }
                }
            }

            this.client_parts = newParts;
        },
        showPreview: function () {
            this.is_playing = false;
            this.checkElementsVisibility(0);
            this.video.load();
        },
        checkElementsVisibility: function (currentTime) {
            let self = this;

            let elements = [self.template.texts, self.template.objects];
            for (let o = 0; o < elements.length; o++) {

                let element = elements[o];
                for (let i = 0; i < element.length; i++) {
                    if (currentTime === 0) {
                        element[i].is_visible = 1;
                    } else {
                        if (parseFloat(element[i].time_start) < currentTime && parseFloat(element[i].time_end) > currentTime) {
                            element[i].is_visible = 1;
                        } else if (parseFloat(element[i].time_start) < currentTime && element[i].time_end === "") {
                            element[i].is_visible = 1;
                        } else {
                            element[i].is_visible = 0;
                        }
                    }
                }
            }
        },
        startInterval: function () {
            let self = this;

            this.interval = setInterval(function () {
                self.checkElementsVisibility(self.video.currentTime);
            }, 30)

        },
        get: function (id) {
            let self = this;

            axios.get(
                `${this.$hostname}/admin/templates/${this.id}`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    let data = response.data;

                    for (let i = 0; i < data.templates[0].texts.length; i++) {
                        data.templates[0].texts[i].is_visible = 1;
                        if (data.templates[0].texts[i].time_start === undefined) {
                            data.templates[0].texts[i].time_start = 0;
                        }
                        if (data.templates[0].texts[i].time_end === undefined) {
                            data.templates[0].texts[i].time_end = "";
                        }

                        if (!data.templates[0].texts[i].direction) {
                            data.templates[0].texts[i].direction = "normal";
                        }

                        if (!data.templates[0].texts[i].animation_type) {
                            data.templates[0].texts[i].animation_type = 0;
                            data.templates[0].texts[i].animation_duration = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_blur) {
                            data.templates[0].texts[i].shadow_blur = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_alpha) {
                            data.templates[0].texts[i].shadow_alpha = 0;
                        }

                        if (!data.templates[0].texts[i].shadow_color) {
                            data.templates[0].texts[i].shadow_color = '#ffffff';
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_size = 0;
                        }

                        if (!data.templates[0].texts[i].stroke_size) {
                            data.templates[0].texts[i].stroke_color = '#000000';
                        }

                    }

                    for (let i = 0; i < data.templates[0].objects.length; i++) {
                        if (!data.templates[0].objects[i].animation_type) {
                            data.templates[0].objects[i].animation_type = 0;
                            data.templates[0].objects[i].animation_duration = 0;
                        }
                    }

                    self.template = JSON.parse(JSON.stringify(data.templates[0]));

                    self.template.parts.forEach((p) => {
                        self.client_parts.push({
                            duration: p.duration,
                            speed: p.speed ? p.speed : "1.0",
                            effect_type: p.effect_type ? p.effect_type : 0,
                            effect_values: p.effect_values ? p.effect_values : {x: 0.5, y: 0.5},
                            collage_type: p.collage_type ? p.collage_type  : 0,
                            frame: p.frame ? p.frame : 0,
                            start_time: p.start_time ? p.start_time : 0,
                        });
                    })

                    if (self.template.release_date) {
                        self.template.release_time = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('HH:mm');
                        self.template.release_date = moment(self.template.release_date, moment.DATETIME_LOCAL_MS).format('YYYY-MM-DD');
                    } else {
                        self.template.release_time = '12:00';
                    }

                    if (self.template.song_insta) {
                        self.template.song_insta = 'https://www.instagram.com/reels/audio/' + self.template.song_insta;
                    }

                    if (self.template.song_tiktok) {
                        self.template.song_tiktok = 'https://vt.tiktok.com/' + self.template.song_tiktok;
                    }

                    if (self.template.objects.length < 1) {
                        self.template.objects = [];
                        self.object_positions = [];
                    } else {

                        for (let i = 0; i < self.template.objects.length; i++) {
                            self.object_positions.push(self.default_positions);

                            let svg = null;
                            _.forEach(self.svg_list, (l) => {
                                if (l.category === self.template.objects[i].category) {
                                    svg = _.find(l.files, (f) => {
                                        return f.id === self.template.objects[i].id;
                                    });
                                }
                            });

                            self.template.objects[i].is_visible = 1;

                            self.template.objects[i].source = svg ? svg.source : "<svg>Default Object</svg>"

                            setTimeout(() => {

                                let centerX = self.template.objects[i].position_x * 360 - self.$refs.draggableContainer2[i].clientWidth / 2;
                                let centerY = self.template.objects[i].position_y * 640 - self.$refs.draggableContainer2[i].clientHeight / 2;

                                self.$refs.draggableContainer2[i].style.left = centerX + 'px';
                                self.$refs.draggableContainer2[i].style.top = centerY + 'px';

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    //console.log('play ' + self.video.currentTime);

                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    //console.log('pause ' + self.video.currentTime);

                                    self.is_playing = false;
                                });


                            }, 500);

                        }

                    }

                    if (self.template.texts.length > 0) {

                        self.is_text_active = true;
                        self.active_text = 0;
                        self.active_type = 'text';

                        for (let i = 0; i < self.template.texts.length; i++) {
                            self.positions.push(self.default_positions);

                            if (!self.template.texts[i].angle) {
                                self.template.texts[i].angle = 0;
                            }

                            setTimeout(() => {

                                let centerX = self.template.texts[i].position_x * 360 - self.$refs.draggableContainer[i].clientWidth / 2;
                                let centerY = self.template.texts[i].position_y * 640 - self.$refs.draggableContainer[i].clientHeight / 2;

                                self.$refs.draggableContainer[i].style.left = centerX + 'px';
                                self.$refs.draggableContainer[i].style.top = centerY + 'px';

                                self.video = self.$refs.videoContainer;

                                self.video.addEventListener("playing", function () {
                                    //console.log('play ' + self.video.currentTime);

                                    self.is_playing = true;
                                });

                                self.video.addEventListener("timeupdate", function () {
                                    self.checkElementsVisibility(self.video.currentTime);
                                });

                                self.video.addEventListener("pause", function () {
                                    //console.log('pause ' + self.video.currentTime);

                                    self.is_playing = false;
                                });


                            }, 500);
                        }


                    }

                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })
                });
        },
        showSVGModal: function () {
            this.show_svg_modal = true;
        },
        closeSVGModal: function (event) {
            if (event && (event.srcElement.className === 'modal-wrapper' ||
                event.srcElement.className.indexOf('modal-close-button')) > -1) {
                this.show_svg_modal = false;
                this.is_object_changing = false;
                this.active_object_category = 'arrows';
            }
        },
        async getSVG() {
            let self = this;

            console.log('get SVG');

            this.waiting = true;

            axios.get(
                `${this.$hostname}/admin/services/svg`,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {

                    self.svg_list = response.data;

                    // This works on all devices/browsers, and uses IndexedDBShim as a final fallback
                    let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

                    let open = indexedDB.open("MuseDatabase");

                    open.onupgradeneeded = function() {
                        let db = open.result;
                        let store = db.createObjectStore("MuseObjectStore", {keyPath: "id"});
                    };

                    open.onsuccess = function() {
                        // Start a new transaction
                        let db = open.result;
                        let tx = db.transaction("MuseObjectStore", "readwrite");
                        let store = tx.objectStore("MuseObjectStore");

                        // Add some data
                        store.put({id: self.$storeVersion, object: self.svg_list});

                        // Close the db when the transaction is done
                        tx.oncomplete = function() {
                            db.close();
                        };
                    }

                    open.onerror = function(error) {
                        console.log(error);
                    }

                    self.get(self.id);

                    self.waiting = false;
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>Ошибка при получении SVG объектов</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    self.waiting = false;
                });

        },
        save: function () {
            let self = this;

            let template = JSON.parse(JSON.stringify(this.template));
            template.parts = self.client_parts;

            if (template.song_insta) {
                const regex = /(\d{14,22})/gi;
                let match = regex.exec(template.song_insta);

                let reelId = match ? match[0] : null;
                template.song_insta = reelId;

                if (!reelId) {
                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на Reels Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }
            }

            if (template.song_tiktok) {
                let parts = template.song_tiktok.split('/');

                if (parts.length > 3 && parts[3].length > 5) {
                    template.song_tiktok = parts[3];
                } else {

                    const notification = {
                        template: `<span><b>Проверьте формат ссылки на TikTok Audio</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                    return false;
                }

            }

            if (this.video) {
                this.showPreview();
            }

            self.waiting = true;

            setTimeout(() => {

                if (this.is_text_active) {

                    for (let i = 0; i < self.template.texts.length; i++) {

                        let activeText = template.texts[i];

                        if (activeText.position_x !== 0.5) {
                            let centerX = this.$refs.draggableContainer[i].offsetLeft + this.$refs.draggableContainer[i].clientWidth / 2;

                            activeText.position_x = parseFloat((centerX / 360).toFixed(4));
                        }

                        if (activeText.position_y !== 0.5) {
                            let centerY = this.$refs.draggableContainer[i].offsetTop + this.$refs.draggableContainer[i].clientHeight / 2;

                            activeText.position_y = parseFloat((centerY / 640).toFixed(4));
                        }


                        activeText.letter_spacing = activeText.letter_spacing == "" ? 0 : activeText.letter_spacing;
                        activeText.line_spacing = activeText.line_spacing == "" ? 0 : activeText.line_spacing;
                        activeText.angle = activeText.angle == "" ? 0 : activeText.angle;
                        activeText.z_index = activeText.z_index == "" ? 0 : activeText.z_index;

                        activeText.font_size = parseFloat(activeText.font_size);
                        activeText.alpha = parseFloat(activeText.alpha);
                        activeText.letter_spacing = parseFloat(activeText.letter_spacing);
                        activeText.line_spacing = parseFloat(activeText.line_spacing);
                        activeText.time_start = parseFloat(activeText.time_start);
                        activeText.shadow_alpha = parseFloat(activeText.shadow_alpha);
                        activeText.shadow_blur = parseInt(activeText.shadow_blur);
                        activeText.animation_type = parseInt(activeText.animation_type);
                        activeText.animation_duration = parseFloat(activeText.animation_duration);
                        activeText.angle = parseInt(activeText.angle);
                        activeText.z_index = parseInt(activeText.z_index);
                        activeText.time_end = activeText.time_end === "" ? "" : parseFloat(activeText.time_end);

                        template.texts[i] = activeText;
                    }


                    for (let i = 0; i < self.template.objects.length; i++) {

                        let activeObj = template.objects[i];

                        let centerX = this.$refs.draggableContainer2[i].offsetLeft + this.$refs.draggableContainer2[i].clientWidth / 2;
                        let centerY = this.$refs.draggableContainer2[i].offsetTop + this.$refs.draggableContainer2[i].clientHeight / 2;

                        activeObj.position_x = parseFloat((centerX / 360).toFixed(4));
                        activeObj.position_y = parseFloat((centerY / 640).toFixed(4));

                        activeObj.scale = parseFloat(activeObj.scale);
                        activeObj.alpha = parseFloat(activeObj.alpha);
                        activeObj.time_start = parseFloat(activeObj.time_start);
                        activeObj.animation_type = parseInt(activeObj.animation_type);
                        activeObj.animation_duration = parseFloat(activeObj.animation_duration);
                        activeObj.angle = activeObj.angle == "" ? 0 : parseInt(activeObj.angle);
                        activeObj.z_index = activeObj.z_index == "" ? 0 : parseInt(activeObj.z_index);
                        activeObj.time_end = activeObj.time_end === "" ? "" : parseFloat(activeObj.time_end);

                        delete activeObj.source;

                        template.objects[i] = activeObj;
                    }


                } else {
                    template.texts = [];
                    template.objects = [];
                }

                if (!template.is_copyrighted) {
                    template.song_insta = "";
                    template.song_tiktok = "";
                }

                template.release_date = template.release_date + ' ' + template.release_time + ':00';

                axios.post(
                    `${this.$hostname}/admin/templates/${this.id}/update`,
                    template,
                    {
                        'headers': {
                            'Authorization': 'Bearer ' + this.token
                        }
                    })
                    .then(function (response) {
                        const notification = {
                            template: `<span><b>Шаблон был успешно изменен</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-explore-2',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'info'
                            })

                        self.waiting = false;

//                    self.$router.push('/templates');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.$notifications.notify(
                            {
                                component: notification,
                                icon: 'nc-icon nc-simple-remove',
                                horizontalAlign: 'right',
                                verticalAlign: 'top',
                                type: 'danger'
                            })

                        self.waiting = false;
                    });


            }, 200);


        },
        remove: function () {
            let self = this;

            axios.post(
                `${this.$hostname}/admin/templates/${this.id}/delete`,
                this.template,
                {
                    'headers': {
                        'Authorization': 'Bearer ' + this.token
                    }
                })
                .then(function (response) {
                    const notification = {
                        template: `<span><b>Изображение было успешно удалено</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-explore-2',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'info'
                        });

                    self.$router.push('/templates');
                })
                .catch(function (error) {

                    const notification = {
                        template: `<span><b>${error.response.data.message}</b></span>`
                    };

                    self.$notifications.notify(
                        {
                            component: notification,
                            icon: 'nc-icon nc-simple-remove',
                            horizontalAlign: 'right',
                            verticalAlign: 'top',
                            type: 'danger'
                        })

                });
        },
        uploadFile: function (event, type) {
            let self = this;

            let formData = new FormData();

            self.waiting = true;

            formData.append('file', event.target.files[0]);

            axios.post(
                `${this.$hostname}/admin/services/file/upload`,
                formData,
                {
                    params: {
                        file_type: type
                    },
                    headers: {
                        'Authorization': 'Bearer ' + this.token,
                        'Content-Type': 'multipart/form-data'
                    }
                }
            ).then(function (response) {
                self.waiting = false;

                let data = JSON.parse(JSON.stringify(response.data));

                self.template[data.file_type] = data.url;
                self.template[data.file_type + '_full'] = data.url_full;
                self.template[data.file_type + '_size'] = data.filesize;

                if (self.video) {
                    self.showPreview();
                }
            })
                .catch(function (error) {
                    self.waiting = false;
                    console.log(error);
                });
        },
        dragMouseDown: function (event) {
            event.preventDefault()

            let path = event.composedPath ? event.composedPath() : event.path;
            let id = null;
            _.each(path, (p) => {
                if (p.className === 'draggable-container') {
                    id = p.id;
                }
            })

            if (!id) {
                return;
            }

            if (id.indexOf('o') > -1) {
                this.draggable_index = id.substring(1);
                this.draggable_type = 'object';

                this.object_positions[this.draggable_index].clientX = event.clientX
                this.object_positions[this.draggable_index].clientY = event.clientY

                document.onmousemove = this.objectDrag
                document.onmouseup = this.closeDragObject
            } else {
                this.draggable_index = id;
                this.draggable_type = 'text';

                this.positions[this.draggable_index].clientX = event.clientX
                this.positions[this.draggable_index].clientY = event.clientY

                document.onmousemove = this.textDrag
                document.onmouseup = this.closeDragText
            }
        },
        textDrag: function (event) {
            event.preventDefault()

            this.positions[this.draggable_index].movementX = this.positions[this.draggable_index].clientX - event.clientX
            this.positions[this.draggable_index].movementY = this.positions[this.draggable_index].clientY - event.clientY
            this.positions[this.draggable_index].clientX = event.clientX
            this.positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer[this.draggable_index].style.top =
                (this.$refs.draggableContainer[this.draggable_index].offsetTop
                    - this.positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer[this.draggable_index].style.left =
                (this.$refs.draggableContainer[this.draggable_index].offsetLeft
                    - this.positions[this.draggable_index].movementX) + 'px'

            let centerX = this.$refs.draggableContainer[this.draggable_index].offsetLeft + this.$refs.draggableContainer[this.draggable_index].clientWidth / 2;
            let centerY = this.$refs.draggableContainer[this.draggable_index].offsetTop + this.$refs.draggableContainer[this.draggable_index].clientHeight / 2;

            this.template.texts[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.texts[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragText() {
            document.onmouseup = null
            document.onmousemove = null

            this.draggable_index = null

            return false;
        },
        objectDrag: function (event) {
            event.preventDefault()

            this.object_positions[this.draggable_index].movementX = this.object_positions[this.draggable_index].clientX - event.clientX
            this.object_positions[this.draggable_index].movementY = this.object_positions[this.draggable_index].clientY - event.clientY
            this.object_positions[this.draggable_index].clientX = event.clientX
            this.object_positions[this.draggable_index].clientY = event.clientY

            this.$refs.draggableContainer2[this.draggable_index].style.top =
                (this.$refs.draggableContainer2[this.draggable_index].offsetTop
                    - this.object_positions[this.draggable_index].movementY) + 'px'

            this.$refs.draggableContainer2[this.draggable_index].style.left =
                (this.$refs.draggableContainer2[this.draggable_index].offsetLeft
                    - this.object_positions[this.draggable_index].movementX) + 'px'


            let centerX = this.$refs.draggableContainer2[this.draggable_index].offsetLeft + this.$refs.draggableContainer2[this.draggable_index].clientWidth / 2;
            let centerY = this.$refs.draggableContainer2[this.draggable_index].offsetTop + this.$refs.draggableContainer2[this.draggable_index].clientHeight / 2;

            this.template.objects[this.draggable_index].position_x = parseFloat((centerX / 360).toFixed(4));
            this.template.objects[this.draggable_index].position_y = parseFloat((centerY / 640).toFixed(4));
        },
        closeDragObject() {
            document.onmouseup = null
            document.onmousemove = null

            this.draggable_index = null

            return false;
        }


    }
}

</script>
<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');
@import url('https://fonts.cdnfonts.com/css/courier-new');
@import url('https://fonts.cdnfonts.com/css/zapfino');
@import url('https://fonts.cdnfonts.com/css/copperplate-gothic-light');
@import url('https://fonts.cdnfonts.com/css/avenir');
@import url('https://fonts.cdnfonts.com/css/menlo');
@import url('https://fonts.cdnfonts.com/css/optima');
@import url('https://fonts.cdnfonts.com/css/savoye-let');
@import url('https://fonts.cdnfonts.com/css/noteworthy');

@font-face {
    font-family: 'Bodoni 72';
    src: URL('/static/fonts/bodoni72.woff') format('woff');
}

@font-face {
    font-family: 'AmaticSC-Bold';
    src: URL('/static/fonts/AmaticSC-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Futura';
    src: URL('/static/fonts/Futura.ttf') format('truetype');
}

@font-face {
    font-family: 'BebasNeue-Regular';
    src: URL('/static/fonts/BebasNeue-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Chilanka-Regular';
    src: URL('/static/fonts/Chilanka-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'DancingScript-Bold';
    src: URL('/static/fonts/DancingScript-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Intro';
    src: URL('/static/fonts/Intro.otf') format('opentype');
}

@font-face {
    font-family: 'JosefinSans-Bold';
    src: URL('/static/fonts/JosefinSans-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Kalam-Bold';
    src: URL('/static/fonts/Kalam-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Lato-Regular';
    src: URL('/static/fonts/Lato-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Lobster-Regular';
    src: URL('/static/fonts/Lobster-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Raleway-Bold';
    src: URL('/static/fonts/Raleway-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Bentoga';
    src: URL('/static/fonts/Bentoga-Thin.ttf') format('truetype');
}

@font-face {
    font-family: 'Brusher';
    src: URL('/static/fonts/Brusher.ttf') format('truetype');
}

@font-face {
    font-family: 'Calistoga';
    src: URL('/static/fonts/Calistoga-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Fondamento';
    src: URL('/static/fonts/Fondamento-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Homemade Apple';
    src: URL('/static/fonts/HomemadeApple-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Luna';
    src: URL('/static/fonts/Luna.ttf') format('truetype');
}

@font-face {
    font-family: 'NewYork';
    src: URL('/static/fonts/NewYork.ttf') format('truetype');
}

@font-face {
    font-family: 'Pathway Gothic';
    src: URL('/static/fonts/PathwayGothicOne-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Quattrocento';
    src: URL('/static/fonts/Quattrocento-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Syne';
    src: URL('/static/fonts/Syne-Bold.ttf') format('truetype');
}

@font-face {
    font-family: 'Thesignature';
    src: URL('/static/fonts/Thesignature.ttf') format('truetype');
}

@font-face {
    font-family: 'Tuesday Night';
    src: URL('/static/fonts/TuesdayNight-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Yellowtail';
    src: URL('/static/fonts/Yellowtail-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Aegean';
    src: URL('/static/fonts/Aegean.ttf') format('truetype');
}

@font-face {
    font-family: 'ALTA';
    src: URL('/static/fonts/ALTA.ttf') format('truetype');
}

@font-face {
    font-family: 'Baskerville';
    src: URL('/static/fonts/Baskerville.ttf') format('truetype');
}

@font-face {
    font-family: 'Belleza';
    src: URL('/static/fonts/Belleza.ttf') format('truetype');
}

@font-face {
    font-family: 'Black Mango';
    src: URL('/static/fonts/Black_Mango.ttf') format('truetype');
}

@font-face {
    font-family: 'Catchy Mager';
    src: URL('/static/fonts/Catchy_Mager.ttf') format('truetype');
}

@font-face {
    font-family: 'Hatton';
    src: URL('/static/fonts/Hatton.ttf') format('truetype');
}

@font-face {
    font-family: 'HUOVA';
    src: URL('/static/fonts/HUOVA.ttf') format('truetype');
}

@font-face {
    font-family: 'Kudryashev';
    src: URL('/static/fonts/Kudryashev.ttf') format('truetype');
}

@font-face {
    font-family: 'Laguna';
    src: URL('/static/fonts/Laguna.ttf') format('truetype');
}

@font-face {
    font-family: 'Liana';
    src: URL('/static/fonts/Liana.ttf') format('truetype');
}

@font-face {
    font-family: 'Lovelace';
    src: URL('/static/fonts/Lovelace.ttf') format('truetype');
}

@font-face {
    font-family: 'Mak';
    src: URL('/static/fonts/Mak.ttf') format('truetype');
}

@font-face {
    font-family: 'Maragsa';
    src: URL('/static/fonts/Maragsa.ttf') format('truetype');
}

@font-face {
    font-family: 'Tan Pearl';
    src: URL('/static/fonts/Tan_Pearl.ttf') format('truetype');
}

@font-face {
    font-family: 'Tenor';
    src: URL('/static/fonts/Tenor.ttf') format('truetype');
}

@font-face {
    font-family: 'The Seasons';
    src: URL('/static/fonts/The_Seasons.ttf') format('truetype');
}

@font-face {
    font-family: 'Amsterdam Four';
    src: URL('/static/fonts/amsterdam-four-ttf.ttf') format('truetype');
}

@font-face {
    font-family: 'Allura';
    src: URL('/static/fonts/Allura.ttf') format('truetype');
}

@font-face {
    font-family: 'Alyssum';
    src: URL('/static/fonts/Alyssum.ttf') format('truetype');
}

@font-face {
    font-family: 'Bangers';
    src: URL('/static/fonts/Bangers.ttf') format('truetype');
}

@font-face {
    font-family: 'Boulder';
    src: URL('/static/fonts/Boulder.ttf') format('truetype');
}

@font-face {
    font-family: 'Carlson';
    src: URL('/static/fonts/Carlson.ttf') format('truetype');
}

@font-face {
    font-family: 'Hello January';
    src: URL('/static/fonts/Hello_January.ttf') format('truetype');
}

@font-face {
    font-family: 'Hit and Run';
    src: URL('/static/fonts/Hit_and_Run.ttf') format('truetype');
}

@font-face {
    font-family: 'Horta';
    src: URL('/static/fonts/Horta.ttf') format('truetype');
}

@font-face {
    font-family: 'Knewave';
    src: URL('/static/fonts/Knewave.ttf') format('truetype');
}

@font-face {
    font-family: 'Lovelies';
    src: URL('/static/fonts/Lovelies.ttf') format('truetype');
}

@font-face {
    font-family: 'Lovelo';
    src: URL('/static/fonts/Lovelo.ttf') format('truetype');
}

@font-face {
    font-family: 'Party Confetti';
    src: URL('/static/fonts/Party_Confetti.ttf') format('truetype');
}

@font-face {
    font-family: 'Peace';
    src: URL('/static/fonts/Peace.ttf') format('truetype');
}

@font-face {
    font-family: 'Petit Cochon';
    src: URL('/static/fonts/Petit_Cochon.ttf') format('truetype');
}

@font-face {
    font-family: 'Playlist';
    src: URL('/static/fonts/Playlist.ttf') format('truetype');
}

@font-face {
    font-family: 'Monoton';
    src: URL('/static/fonts/Monoton.ttf') format('truetype');
}

@font-face {
    font-family: 'Pushkin';
    src: URL('/static/fonts/Pushkin.ttf') format('truetype');
}

@font-face {
    font-family: 'Sarina';
    src: URL('/static/fonts/Sarina.ttf') format('truetype');
}

@font-face {
    font-family: 'Shrikhand';
    src: URL('/static/fonts/Shrikhand.ttf') format('truetype');
}

@font-face {
    font-family: 'Studly';
    src: URL('/static/fonts/Studly.ttf') format('truetype');
}

@font-face {
    font-family: 'The Youngest';
    src: URL('/static/fonts/The_Youngest.ttf') format('truetype');
}

@font-face {
    font-family: 'Amsterdam One';
    src: URL('/static/fonts/AmsterdamOne-eZ12l.ttf') format('truetype');
}

@font-face {
    font-family: 'Brittany';
    src: URL('/static/fonts/BrittanySignature.ttf') format('truetype');
}

@font-face {
    font-family: 'Daydream';
    src: URL('/static/fonts/daydream.ttf') format('truetype');
}

@font-face {
    font-family: 'Inters';
    src: URL('/static/fonts/Inters.ttf') format('truetype');
}

@font-face {
    font-family: 'Kavivanar';
    src: URL('/static/fonts/Kavivanar-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Mixa';
    src: URL('/static/fonts/Mixa-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Sisterhood';
    src: URL('/static/fonts/Sisterhood.ttf') format('truetype');
}

@font-face {
    font-family: 'Virtual';
    src: URL('/static/fonts/Virtual-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Anton';
    src: URL('/static/fonts/Anton.ttf') format('truetype');
}

@font-face {
    font-family: 'Blue-Ocean';
    src: URL('/static/fonts/Blue-Ocean.ttf') format('truetype');
}

@font-face {
    font-family: 'Cormorant';
    src: URL('/static/fonts/Cormorant.ttf') format('truetype');
}

@font-face {
    font-family: 'Culture';
    src: URL('/static/fonts/Culture.ttf') format('truetype');
}

@font-face {
    font-family: 'Kingthings';
    src: URL('/static/fonts/Kingthings.ttf') format('truetype');
}

@font-face {
    font-family: 'Keep-on-Truckin';
    src: URL('/static/fonts/Keep-on-Truckin.ttf') format('truetype');
}

@font-face {
    font-family: 'Maharlika';
    src: URL('/static/fonts/Maharlika.ttf') format('truetype');
}

@font-face {
    font-family: 'Montserrat';
    src: URL('/static/fonts/Montserrat.ttf') format('truetype');
}

@font-face {
    font-family: 'Nectarine';
    src: URL('/static/fonts/Nectarine.ttf') format('truetype');
}

@font-face {
    font-family: 'Sandy';
    src: URL('/static/fonts/Sandy.ttf') format('truetype');
}

@font-face {
    font-family: 'Tan-Paradiso';
    src: URL('/static/fonts/Tan-Paradiso.ttf') format('truetype');
}

@font-face {
    font-family: 'Well-Cake';
    src: URL('/static/fonts/Well-Cake.ttf') format('truetype');
}

@font-face {
    font-family: 'Agrandir';
    src: URL('/static/fonts/Agrandir-WideBlackItalic.otf') format('opentype');
}

@font-face {
    font-family: 'BlackGold';
    src: URL('/static/fonts/blackgold.regular.otf') format('opentype');
}

@font-face {
    font-family: 'Bright';
    src: URL('/static/fonts/BrightDemo.otf') format('opentype');
}

@font-face {
    font-family: 'Brown Sugar';
    src: URL('/static/fonts/Brown-Sugar.otf') format('opentype');
}

@font-face {
    font-family: 'Garet';
    src: URL('/static/fonts/Garet-Book.otf') format('opentype');
}

@font-face {
    font-family: 'Harmony';
    src: URL('/static/fonts/HARMONY.otf') format('opentype');
}

@font-face {
    font-family: 'Migra';
    src: URL('/static/fonts/Migra-Extralight.ttf') format('truetype');
}

@font-face {
    font-family: 'Migra Italic';
    src: URL('/static/fonts/MigraItalic-ExtralightItalic.ttf') format('truetype');
}

@font-face {
    font-family: 'Noto Serif Display';
    src: URL('/static/fonts/NotoSerifDisplay-ExtraCondensed.ttf') format('truetype');
}

@font-face {
    font-family: 'Pinyon Script';
    src: URL('/static/fonts/PinyonScript-Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Sloop Script';
    src: URL('/static/fonts/Sloop Script Regular.ttf') format('truetype');
}

@font-face {
    font-family: 'Redkits';
    src: URL('/static/fonts/RedKits.otf') format('opentype');
}

@font-face {
    font-family: 'Sceageus';
    src: URL('/static/fonts/Sceageus.otf') format('opentype');
}

@font-face {
    font-family: 'Tan Nimbus';
    src: URL('/static/fonts/TAN-NIMBUS.otf') format('opentype');
}

@font-face {
    font-family: 'Kenao';
    src: URL('/static/fonts/Kenao.otf') format('opentype');
}



.range {
    cursor: pointer !important;
}

#preview-container {
    display: block;
    margin: 0 auto 30px auto;
    width: 360px;
}

.object-preview {
    width: 100px;
    display: block;
    cursor: pointer;
    margin-bottom: 15px;
}

#preview {
    position: relative;
    width: 360px;
    height: 640px;
    overflow: hidden;
    background-size: cover;
    background-position: center;
}

#preview::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.25);
}

#player {
    width: 360px;
    height: 640px;
    position: relative;
    top: 0;
    background: #fff;
    z-index: 11;
    transition: all .3s ease-out;
}

video::-webkit-media-controls-fullscreen-button {
    display: none !important;
}

.btn-toggle {
    width: 360px;
    height: 40px;
    margin: 33px auto;
    background: #000;
    border: none;
    font-size: 15px;
    opacity: 1;
    color: #fff;
}

.btn-toggle:hover {
    opacity: 0.8 !important;
}

.btn-toggle.active-state {
    display: block;
}

.draggable-header {
    white-space: pre;
    cursor: pointer;
    z-index: 10;
}

.draggable-header.nospace {
    white-space: normal;
    padding: 0;
}

.draggable-container {
    top: 0px;
    position: absolute;
    z-index: 9;
}

.text-area {
    width: 100%;
    padding: 8px 12px;
}

.btn-save {
    width: 150px;
}

.btn-info.btn-fill, .btn-info.btn-fill:active {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-top: 8px;
}

.btn-text, .btn-text:active, .btn-text:hover {
    color: #000;
    background-color: #FFFFFF;
    border: 1px solid #000000;
    margin-right: 5px;
    margin-bottom: 5px;
}

.btn-text.active {
    color: #000;
    background-color: #D5C9E9;
    border: 1px solid #D5C9E9;
}

.btn-text:hover {
    opacity: 0.6;
}

.btn-text.control-btn {
    color: #54abfe;
    background-color: #FFFFFF;
    border: 1px solid #54abfe;
    margin-left: 25px;
}

.button-preview {
    max-height: 20px;
    width: 70px;
}

.button-preview:active {
    background: transparent;
}

.control-btn:last-child {
    margin-left: 0px;
}

.btn-remove, .btn-remove:active {
    color: rgba(255, 70, 50);
    border: 1px solid rgba(255, 70, 50);
    background-color: transparent;
    margin-top: 20px
}

.checkbox-block {
    margin-top: 20px;
    margin-left: 20px;
}


.color-set span {
    width: 37px;
    height: 26px;
    display: inline-block;
    margin-left: 5px;
    border-radius: 5px;
    cursor: pointer;
}

.color-set span:first-child {
    border: 1px solid #E3E3E3;
}

.color-set span.active {
    border: 1px solid #000000;
}

.btn-file {
    display: none;
}

.upload-button {
    margin-top: 10px;
}

.inline-link {
    font-size: 16px;
    margin-left: 5px;
}

.inline-link span, h4 .bg-danger {
    padding: 3px;
    border-radius: 4px;
}

.bg-danger {
    font-size: 16px;
    background-color: rgba(255, 70, 50, 0.5) !important;
}

.image-block {
    max-width: 100%;
}

.form-check-inline {
    display: inline-block;
    cursor: pointer;
}

.label-checkbox {
    margin-right: 10px;
    cursor: pointer;
}

.link {
    cursor: pointer;
    text-decoration: underline;
}

.card-body p {
    font-weight: 300;
    font-style: italic;
}

.card-body form {
    margin-top: 15px;
}

.mb10 {
    margin-bottom: 10px
}

.device-block {
    position: relative;
    background-position: center center;
    background-size: cover;
    cursor: pointer;
}

.device-block img {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 18px;
    top: 18px;
}

.device-block span {
    position: absolute;
    top: -30px;
    left: 5px;
}

.param-span, .param-span label {
    font-size: 0.8rem;
    color: #000;
}

.loader {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 100%;
    height: 100%;
    background-color: #eceaea;
    background-image: url('/static/img/oval.svg');
    background-size: 50px;
    background-repeat: no-repeat;
    background-position: center;
    z-index: 10000000;
    opacity: 0.7;
    filter: alpha(opacity=40);
}

.modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 1.7s ease;
}

.modal-wrapper {
    display: table-cell;
    vertical-align: middle;
}

.modal-container {
    width: 1000px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 1.7s ease;
}


.modal-header h3 {
    margin-top: 0;
    color: #42b983;
}

.modal-header button {
    text-transform: capitalize;
}

.modal-body {
    margin: 20px 0;
}

.object-item {
    display: inline-block;
    width: 60px;
    height: 60px;
    margin-right: 20px;
    cursor: pointer;
    margin-bottom: 10px;
}

.object-item:first-child {
    margin-left: 0;
}

.object-item:hover {
    opacity: 0.6;
}

.object-item img {
    width: 100%;
    height: 100%;
    display: block;
}

.modal-header {
    padding-left: 0;
    display: block;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.texts-buttons button {
    position: relative;
}
.animated-icon {
    font-size: 30px;
    position: absolute;
    color: #6dc030;
    top: -15px;
    right: 0;
}
.effect-values {
    display: block;
    width: 100%;
    font-size: 10px;
    text-transform: uppercase;
    margin-left: 15px;
    color: #9A9A9A;
}
.effect-preview {
    width: 50px;
    height: 89px;
    margin-left: 9px;
    display: block;
    border: 1px solid #E3E3E3;
    cursor: pointer;
    position: relative;
}
.effect-area {
    width: 30px;
    height: 30px;
    border: 1px solid #FFD700;
    border-radius: 50%;
    display: block;
    position: relative;
    top: 10px;
    left: 10px
}
.effect-center {
    display: block;
    width: 8px;
    height: 8px;
    background: #FFD700;
    border-radius: 50%;
    position: absolute;
    top: 10px;
    left: 10px;
}
.bordered {
    border-bottom: 1px solid #dee2e6;
}
.row {
    margin-right: -13px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Template/Edit.vue